const colors = {
  black: {
    900: '#111111',
    850: '#1C1D1D',
    800: '#282828',
    700: '#383838',
    600: '#4B4B4B',
    500: '#9D9FA1',
    400: '#BDBDBD',
    300: '#DDDDDD',
    200: '#EEEEEE',
    100: '#F2F2F2',
    50: '#F9F9F9',
  },
  key: {
    800: '#1B1B40B3',
    700: '#1E1B99',
    500: '#312DFF',
    400: '#5A57FF',
    100: '#D6D5FF',
    50: '#E8E8FF',
  },
  gradient: {
    keyGradient: 'linear-gradient(89.99deg, #5A57FF -14.57%, #1E1B99 99.99%)',
    keyGradient50: 'linear-gradient(89.99deg, rgba(90, 87, 255, 0.5) -14.57%, rgba(30, 27, 153, 0.5) 99.99%)',
    keyGradientDark: 'linear-gradient(89.99deg, #21204C -14.57%, #151534 99.99%)',
    keyGradientHover: 'linear-gradient(89.99deg, #4845D6 -14.57%, #17157F 99.99%)',
  },
};

export default colors;
